module.exports = __webpack_public_path__ + "media/images/pulse-settings-video-image-3fae58982be323d950c127caa7381251.png";